import api from '@/services/api'
import type { Badge } from '@/types/shared/player'
import { BADGE_ID } from '@/types/shared/player'
import { computed, ref } from 'vue'
import { liveOpsCurrencies } from '@/composables/game/live-ops-events'
import { player } from '@/composables/game/player'
import GoldBadge from '@/assets/images/badges/medal-gold.png'
import SilverBadge from '@/assets/images/badges/medal-silver.png'
import BronzeBadge from '@/assets/images/badges/medal-bronze.png'
import AlphaBadge from '@/assets/images/badges/badge-satoshis-scout.png'
import BetaBadge from '@/assets/images/badges/badge-crypto-beta-pioneer.png'
import DefiAngelBadge from '@/assets/images/badges/badge-defi-angel.png'
import DiscordOgBadge from '@/assets/images/badges/discord-og.webp'
import BlockchainSponsorBadge from '@/assets/images/badges/badge-blockchain-sponsor.png'
import CryptoPatronBadge from '@/assets/images/badges/badge-crypto-patron.png'
import TokenMogulBadge from '@/assets/images/badges/badge-token-mogul.png'
import BlockBuilderBadge from '@/assets/images/badges/badge-block-builder.png'
import BlockchainPathfinderBadge from '@/assets/images/badges/badge-blockchain-pathfinder.png'
import CryptoCrusaderBadge from '@/assets/images/badges/badge-crypto-crusader.png'
import OnChainChampionBadge from '@/assets/images/badges/badge-on-chain-champion.png'
import OnChainTitanBadge from '@/assets/images/badges/badge-on-chain-titan.png'
import GrandPatronBadge from '@/assets/images/badges/badge-grand-patron.png'
import EcosystemGuardianBadge from '@/assets/images/badges/badge-ecosystem-guardian.png'
import Top1Badge from '@/assets/images/badges/badge-top-1.png'
import Top2Badge from '@/assets/images/badges/badge-top-2.png'
import Top3Badge from '@/assets/images/badges/badge-top-3.png'
import Top50Badge from '@/assets/images/badges/badge-top-50.png'
import PathwayConquerorBadge from '@/assets/images/badges/badge-pathway-explorer.png'
import PathwayExplorerBadge from '@/assets/images/badges/badge-pathway-conqueror.png'
import PathwayLegendBadge from '@/assets/images/badges/badge-pathway-legend.png'
import EasterChampionBadge from '@/assets/images/badges/badge-egg1.png'
import EasterLegendBadge from '@/assets/images/badges/badge-egg2.png'
import EasterProBadge from '@/assets/images/badges/badge-egg3.png'
import EasterMasterBadge from '@/assets/images/badges/badge-egg4.png'
import PathwayPlantChampionBadge from '@/assets/images/badges/badge-plant1.png'
import PathwayPlantLegendBadge from '@/assets/images/badges/badge-plant2.png'
import PathwayPlantProBadge from '@/assets/images/badges/badge-plant3.png'
import PathwayPlantMasterBadge from '@/assets/images/badges/badge-plant4.png'
import PathwayKeyChampionBadge from '@/assets/images/badges/badge-key1.png'
import PathwayKeyLegendBadge from '@/assets/images/badges/badge-key2.png'
import PathwayKeyProBadge from '@/assets/images/badges/badge-key3.png'
import PathwayKeyMasterBadge from '@/assets/images/badges/badge-key4.png'
import PathwayChallenge1Badge from '@/assets/images/badges/badge-pathway-challenge1.png'
import PathwayChallenge2Badge from '@/assets/images/badges/badge-pathway-challenge2.png'
import PathwayChallenge3Badge from '@/assets/images/badges/badge-pathway-challenge3.png'
import PathwayChallenge4Badge from '@/assets/images/badges/badge-pathway-challenge4.png'
import PuzzleChallenge1Badge from '@/assets/images/badges/badge-puzzle-challenge1.webp'
import PuzzleChallenge2Badge from '@/assets/images/badges/badge-puzzle-challenge2.webp'
import PuzzleChallenge3Badge from '@/assets/images/badges/badge-puzzle-challenge3.webp'
import PuzzleChallenge4Badge from '@/assets/images/badges/badge-puzzle-challenge4.webp'
import MemoryGameChallenge1Badge from '@/assets/images/badges/badge-memory-game-champion.webp'
import MemoryGameChallenge2Badge from '@/assets/images/badges/badge-memory-game-legend.webp'
import MemoryGameChallenge3Badge from '@/assets/images/badges/badge-memory-game-master.webp'
import MemoryGameChallenge4Badge from '@/assets/images/badges/badge-memory-game-pro.webp'
import MinesweeperGameChallenge1Badge from '@/assets/images/badges/badge-minesweeper-game-champion.webp'
import MinesweeperGameChallenge2Badge from '@/assets/images/badges/badge-minesweeper-game-legend.webp'
import MinesweeperGameChallenge3Badge from '@/assets/images/badges/badge-minesweeper-game-master.webp'
import MinesweeperGameChallenge4Badge from '@/assets/images/badges/badge-minesweeper-game-pro.webp'
import Parachute1Badge from '@/assets/images/badges/badge-parachute1.webp'
import Parachute2Badge from '@/assets/images/badges/badge-parachute2.webp'
import Parachute3Badge from '@/assets/images/badges/badge-parachute3.webp'
import Parachute4Badge from '@/assets/images/badges/badge-parachute4.webp'
import HolidayOrb1Badge from '@/assets/images/badges/badge-holiday-orb1.webp'
import HolidayOrb2Badge from '@/assets/images/badges/badge-holiday-orb2.webp'
import HolidayOrb3Badge from '@/assets/images/badges/badge-holiday-orb3.webp'
import HolidayOrb4Badge from '@/assets/images/badges/badge-holiday-orb4.webp'
import CollectibleHunt1Badge from '@/assets/images/badges/badge-collectible-hunt1.webp'
import CollectibleHunt2Badge from '@/assets/images/badges/badge-collectible-hunt2.webp'
import CollectibleHunt3Badge from '@/assets/images/badges/badge-collectible-hunt3.webp'
import CollectibleHunt4Badge from '@/assets/images/badges/badge-collectible-hunt4.webp'
import OneYearBadge from '@/assets/images/badges/badge-1year.webp'
import CosmicLoverImage from '@/assets/images/badges/badge-cosmic-lover.webp'
import CommunityMascot1Image from '@/assets/images/badges/badge-community-mascot1.webp'

export type OrderedBadge = Badge & { order: number }

const medalIcons = {
  gold: GoldBadge,
  silver: SilverBadge,
  bronze: BronzeBadge,
}
export const availableBadges: OrderedBadge[] = [
  {
    id: BADGE_ID.GRAND_PATRON,
    name: `Grand Patron`,
    imageUrl: GrandPatronBadge,
    order: 1,
  },
  {
    id: BADGE_ID.ECOSYSTEM_GUARDIAN,
    name: `Ecosystem Guardian`,
    imageUrl: EcosystemGuardianBadge,
    order: 1,
  },
  {
    id: BADGE_ID.ALPHA,
    name: `Satoshi's Scout`,
    imageUrl: AlphaBadge,
    order: 1,
  },
  {
    id: BADGE_ID.BETA,
    name: `Crypto Beta Pioneer`,
    imageUrl: BetaBadge,
    order: 2,
  },
  {
    id: BADGE_ID.ONE_YEAR,
    name: `1 year on Dropee`,
    imageUrl: OneYearBadge,
    order: 2,
  },
  {
    id: BADGE_ID.DISCORD_OG,
    name: `Discord OG`,
    imageUrl: DiscordOgBadge,
    order: 2,
  },
  {
    id: BADGE_ID.DEFI_ANGEL,
    name: `DeFi Angel`,
    imageUrl: DefiAngelBadge,
    order: 3,
  },
  {
    id: BADGE_ID.BLOCKCHAIN_SPONSOR,
    name: `Blockchain Sponsor`,
    imageUrl: BlockchainSponsorBadge,
    order: 4,
  },
  {
    id: BADGE_ID.CRYPTO_PATRON,
    name: `Crypto Patron`,
    imageUrl: CryptoPatronBadge,
    order: 5,
  },
  {
    id: BADGE_ID.TOKEN_MOGUL,
    name: `Token Mogul`,
    imageUrl: TokenMogulBadge,
    order: 6,
  },
  {
    id: BADGE_ID.BLOCKCHAIN_PATHFINDER,
    name: `Blockchain Pathfinder`,
    imageUrl: BlockchainPathfinderBadge,
    order: 7,
  },
  {
    id: BADGE_ID.BLOCK_BUILDER,
    name: `Block Builder`,
    imageUrl: BlockBuilderBadge,
    order: 8,
  },
  {
    id: BADGE_ID.CRYPTO_CRUSADER,
    name: `Crypto Crusader`,
    imageUrl: CryptoCrusaderBadge,
    order: 9,
  },
  {
    id: BADGE_ID.ONCHAIN_CHAMPION,
    name: `On-Chain Champion`,
    imageUrl: OnChainChampionBadge,
    order: 10,
  },
  {
    id: BADGE_ID.ONCHAIN_TITAN,
    name: `On-Chain Titan`,
    imageUrl: OnChainTitanBadge,
    order: 11,
  },
  {
    id: BADGE_ID.PATHWAY_EXPLORER,
    name: `Pathway Explorer`,
    imageUrl: PathwayExplorerBadge,
    order: 12,
  },
  {
    id: BADGE_ID.PATHWAY_CONQUEROR,
    name: `Pathway Conqueror`,
    imageUrl: PathwayConquerorBadge,
    order: 13,
  },
  {
    id: BADGE_ID.PATHWAY_LEGEND,
    name: `Pathway Legend`,
    imageUrl: PathwayLegendBadge,
    order: 14,
  },
  {
    id: BADGE_ID.EASTER_HUNT_CHAMPION,
    name: `Easter Hunt Champion`,
    imageUrl: EasterChampionBadge,
    order: 15,
  },
  {
    id: BADGE_ID.EASTER_HUNT_LEGEND,
    name: `Easter Hunt Legend`,
    imageUrl: EasterLegendBadge,
    order: 16,
  },
  {
    id: BADGE_ID.EASTER_HUNT_PRO,
    name: `Easter Hunt Pro`,
    imageUrl: EasterProBadge,
    order: 17,
  },
  {
    id: BADGE_ID.EASTER_HUNT_MASTER,
    name: `Top 50 Easter Hunt Master`,
    imageUrl: EasterMasterBadge,
    order: 18,
  },
  {
    id: BADGE_ID.PLANT_PATHWAY_CHAMPION,
    name: `Plant Pathway Champion`,
    imageUrl: PathwayPlantChampionBadge,
    order: 19,
  },
  {
    id: BADGE_ID.PLANT_PATHWAY_LEGEND,
    name: `Plant Pathway Legend`,
    imageUrl: PathwayPlantLegendBadge,
    order: 20,
  },
  {
    id: BADGE_ID.PLANT_PATHWAY_PRO,
    name: `Plant Pathway Pro`,
    imageUrl: PathwayPlantProBadge,
    order: 21,
  },
  {
    id: BADGE_ID.PLANT_PATHWAY_MASTER,
    name: `Plant Pathway Master`,
    imageUrl: PathwayPlantMasterBadge,
    order: 22,
  },
  {
    id: BADGE_ID.KEY_PATHWAY_CHAMPION,
    name: `Key Pathway Champion`,
    imageUrl: PathwayKeyChampionBadge,
    order: 23,
  },
  {
    id: BADGE_ID.KEY_PATHWAY_LEGEND,
    name: `Key Pathway Legend`,
    imageUrl: PathwayKeyLegendBadge,
    order: 24,
  },
  {
    id: BADGE_ID.KEY_PATHWAY_PRO,
    name: `Key Pathway Pro`,
    imageUrl: PathwayKeyProBadge,
    order: 25,
  },
  {
    id: BADGE_ID.KEY_PATHWAY_MASTER,
    name: `Key Pathway Master`,
    imageUrl: PathwayKeyMasterBadge,
    order: 26,
  },
  {
    id: BADGE_ID.ALL_TIME_CARD_1,
    name: `Gold All-Time Card Master`,
    imageUrl: Top1Badge,
    order: 100,
  },
  {
    id: BADGE_ID.ALL_TIME_CARD_2,
    name: `Silver All-Time Card Master`,
    imageUrl: Top2Badge,
    order: 101,
  },
  {
    id: BADGE_ID.ALL_TIME_CARD_3,
    name: `Bronze All-Time Card Master`,
    imageUrl: Top3Badge,
    order: 103,
  },
  {
    id: BADGE_ID.ALL_TIME_CARD_4,
    name: `Bronze All-Time Card Master`,
    imageUrl: Top50Badge,
    order: 104,
  },
  {
    id: BADGE_ID.DAILY_CARD_1,
    name: `Gold Daily Card Master`,
    imageUrl: medalIcons.gold,
    order: 105,
  },
  {
    id: BADGE_ID.DAILY_CARD_2,
    name: `Silver Daily Card Master`,
    imageUrl: medalIcons.silver,
    order: 106,
  },
  {
    id: BADGE_ID.DAILY_CARD_3,
    name: `Bronze Daily Card Master`,
    imageUrl: medalIcons.bronze,
    order: 107,
  },
  {
    id: BADGE_ID.WEEKLY_CARD_1,
    name: `Gold Weekly Card Master`,
    imageUrl: medalIcons.gold,
    order: 108,
  },
  {
    id: BADGE_ID.WEEKLY_CARD_2,
    name: `Silver Weekly Card Master`,
    imageUrl: medalIcons.silver,
    order: 109,
  },
  {
    id: BADGE_ID.WEEKLY_CARD_3,
    name: `Bronze Weekly Card Master`,
    imageUrl: medalIcons.bronze,
    order: 110,
  },
  {
    id: BADGE_ID.PATHWAY_CHALLENGE1,
    name: `Pathway Finisher Champion`,
    imageUrl: PathwayChallenge1Badge,
    order: 200,
  },
  {
    id: BADGE_ID.PATHWAY_CHALLENGE2,
    name: `Pathway Finisher Legend`,
    imageUrl: PathwayChallenge2Badge,
    order: 201,
  },
  {
    id: BADGE_ID.PATHWAY_CHALLENGE3,
    name: `Pathway Finisher Master`,
    imageUrl: PathwayChallenge3Badge,
    order: 202,
  },
  {
    id: BADGE_ID.PATHWAY_CHALLENGE4,
    name: `Pathway Finisher Pro`,
    imageUrl: PathwayChallenge4Badge,
    order: 203,
  },
  {
    id: BADGE_ID.PUZZLE_CHALLENGE1,
    name: `Jigsaw Champion`,
    imageUrl: PuzzleChallenge1Badge,
    order: 204,
  },
  {
    id: BADGE_ID.PUZZLE_CHALLENGE2,
    name: `Jigsaw Legend`,
    imageUrl: PuzzleChallenge2Badge,
    order: 205,
  },
  {
    id: BADGE_ID.PUZZLE_CHALLENGE3,
    name: `Jigsaw Master`,
    imageUrl: PuzzleChallenge3Badge,
    order: 206,
  },
  {
    id: BADGE_ID.PUZZLE_CHALLENGE4,
    name: `Jigsaw Pro`,
    imageUrl: PuzzleChallenge4Badge,
    order: 207,
  },
  {
    id: BADGE_ID.MEMORY_GAME_CHALLENGE1,
    name: `Memory Game Champion`,
    imageUrl: MemoryGameChallenge1Badge,
    order: 300,
  },
  {
    id: BADGE_ID.MEMORY_GAME_CHALLENGE2,
    name: `Memory Game Legend`,
    imageUrl: MemoryGameChallenge2Badge,
    order: 301,
  },
  {
    id: BADGE_ID.MEMORY_GAME_CHALLENGE3,
    name: `Memory Game Master`,
    imageUrl: MemoryGameChallenge3Badge,
    order: 302,
  },
  {
    id: BADGE_ID.MEMORY_GAME_CHALLENGE4,
    name: `Memory Game Pro`,
    imageUrl: MemoryGameChallenge4Badge,
    order: 303,
  },
  {
    id: BADGE_ID.MINESWEEPER_GAME_CHALLENGE1,
    name: `Minesweeper Game Champion`,
    imageUrl: MinesweeperGameChallenge1Badge,
    order: 304,
  },
  {
    id: BADGE_ID.MINESWEEPER_GAME_CHALLENGE2,
    name: `Minesweeper Game Legend`,
    imageUrl: MinesweeperGameChallenge2Badge,
    order: 305,
  },
  {
    id: BADGE_ID.MINESWEEPER_GAME_CHALLENGE3,
    name: `Minesweeper Game Master`,
    imageUrl: MinesweeperGameChallenge3Badge,
    order: 306,
  },
  {
    id: BADGE_ID.MINESWEEPER_GAME_CHALLENGE4,
    name: `Minesweeper Game Pro`,
    imageUrl: MinesweeperGameChallenge4Badge,
    order: 307,
  },
  {
    id: BADGE_ID.PARACHUTE1,
    name: `Dropkey Champion`,
    imageUrl: Parachute1Badge,
    order: 308,
  },
  {
    id: BADGE_ID.PARACHUTE2,
    name: `Dropkey Commander`,
    imageUrl: Parachute2Badge,
    order: 309,
  },
  {
    id: BADGE_ID.PARACHUTE3,
    name: `Dropkey Ace`,
    imageUrl: Parachute3Badge,
    order: 310,
  },
  {
    id: BADGE_ID.PARACHUTE4,
    name: `Dropkey Initiate`,
    imageUrl: Parachute4Badge,
    order: 311,
  },
  {
    id: BADGE_ID.COLLECTIBLE_HUNT_1,
    name: `Collectible Hunt Champion`,
    imageUrl: CollectibleHunt1Badge,
    order: 312,
  },
  {
    id: BADGE_ID.COLLECTIBLE_HUNT_2,
    name: `Collectible Hunt Commander`,
    imageUrl: CollectibleHunt2Badge,
    order: 313,
  },
  {
    id: BADGE_ID.COLLECTIBLE_HUNT_3,
    name: `Collectible Hunt Ace`,
    imageUrl: CollectibleHunt3Badge,
    order: 314,
  },
  {
    id: BADGE_ID.COLLECTIBLE_HUNT_4,
    name: `Collectible Hunt Initiate`,
    imageUrl: CollectibleHunt4Badge,
    order: 315,
  },
  {
    id: BADGE_ID.HOLIDAY_ORB1,
    name: `Holiday Hunt Champion`,
    imageUrl: HolidayOrb1Badge,
    order: 312,
  },
  {
    id: BADGE_ID.HOLIDAY_ORB2,
    name: `Holiday Hunt Commander`,
    imageUrl: HolidayOrb2Badge,
    order: 313,
  },
  {
    id: BADGE_ID.HOLIDAY_ORB3,
    name: `Holiday Hunt Ace`,
    imageUrl: HolidayOrb3Badge,
    order: 314,
  },
  {
    id: BADGE_ID.HOLIDAY_ORB4,
    name: `Holiday Hunt Initiate`,
    imageUrl: HolidayOrb4Badge,
    order: 315,
  },
  {
    id: BADGE_ID.COSMIC_LOVER,
    name: `Cosmic Lover`,
    imageUrl: CosmicLoverImage,
    order: 316,
  },
  {
    id: BADGE_ID.COMMUNITY_MASCOT1,
    name: `Community Mascot #1`,
    imageUrl: CommunityMascot1Image,
    order: 317,
  },
]
export const availableBadgesMap = availableBadges.reduce((acc, badge) => ({
  ...acc,
  [badge.id]: badge,
}), {} as Record<string, OrderedBadge>)

const badges = ref<Record<string, number>>({})

export const badgeIdsWithCount = [
  BADGE_ID.DAILY_CARD_1, BADGE_ID.DAILY_CARD_2, BADGE_ID.DAILY_CARD_3, BADGE_ID.WEEKLY_CARD_1, BADGE_ID.WEEKLY_CARD_2, BADGE_ID.WEEKLY_CARD_3,
  BADGE_ID.PATHWAY_CHALLENGE1, BADGE_ID.PATHWAY_CHALLENGE2, BADGE_ID.PATHWAY_CHALLENGE3, BADGE_ID.PATHWAY_CHALLENGE4,
  BADGE_ID.PUZZLE_CHALLENGE1, BADGE_ID.PUZZLE_CHALLENGE2, BADGE_ID.PUZZLE_CHALLENGE3, BADGE_ID.PUZZLE_CHALLENGE4,
  BADGE_ID.MEMORY_GAME_CHALLENGE1, BADGE_ID.MEMORY_GAME_CHALLENGE2, BADGE_ID.MEMORY_GAME_CHALLENGE3, BADGE_ID.MEMORY_GAME_CHALLENGE4,
  BADGE_ID.MINESWEEPER_GAME_CHALLENGE1, BADGE_ID.MINESWEEPER_GAME_CHALLENGE2, BADGE_ID.MINESWEEPER_GAME_CHALLENGE3, BADGE_ID.MINESWEEPER_GAME_CHALLENGE4,
  BADGE_ID.PARACHUTE1, BADGE_ID.PARACHUTE2, BADGE_ID.PARACHUTE3, BADGE_ID.PARACHUTE4,
  BADGE_ID.COLLECTIBLE_HUNT_1, BADGE_ID.COLLECTIBLE_HUNT_2, BADGE_ID.COLLECTIBLE_HUNT_3, BADGE_ID.COLLECTIBLE_HUNT_4,
]

const liveOpsBadgeCurrencies = computed(() =>
  liveOpsCurrencies.value.filter(c => c.id.startsWith('badge.')),
)
const formatBadgeName = (str: string) => {
  return str
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (s) => s.toUpperCase())
    .trim();
}
export const allBadgesMap = computed<Record<string, OrderedBadge>>(() => {
  const merged: Record<string, OrderedBadge> = { ...availableBadgesMap }
  for (const [index, currency] of liveOpsBadgeCurrencies.value.entries()) {
    const trimmedId = currency.id.slice('badge.'.length)
    if (!(trimmedId in merged)) {
      merged[trimmedId] = { id: trimmedId as BADGE_ID, name: formatBadgeName(trimmedId), imageUrl: currency.mediaUrl, order: 1000 + index }
    }
  }
  return merged
})

export const useBadges = () => {
  const badgesWithCount = computed<{
    badge: OrderedBadge,
    count: number,
    showCount?: boolean
  }[]>(() => {
    const hardcoded = availableBadges.map((item) => ({
      badge: item,
      count: badges.value[item.id] ?? 0,
      showCount: badgeIdsWithCount.includes(item.id),
    }))
    const liveOps = Object.entries(player.value.specialCurrencies)
      .filter(([key, count]) => key.startsWith('badge.') && (count ?? 0) > 0)
      .map(([key, count], index) => {
        const trimmedId = key.slice('badge.'.length)
        const liveOpsCurrency = liveOpsBadgeCurrencies.value.find(c => c.id === key)
        const hardcodedBadge = availableBadgesMap[trimmedId]
        return {
          badge: {
            id: trimmedId as BADGE_ID,
            name: liveOpsCurrency?.name ?? hardcodedBadge?.name ?? trimmedId,
            imageUrl: liveOpsCurrency?.mediaUrl ?? hardcodedBadge?.imageUrl ?? '',
            order: 1000 + index,
          },
          count: count ?? 0,
          showCount: (count ?? 0) > 1,
        }
      })
    return [...hardcoded, ...liveOps]
  })

  async function getBadges() {
    const { badges: badgeCounts } = await api.getBadgesV2()
    badges.value = badgeCounts
  }

  return {
    badges,
    badgesWithCount,
    getBadges,
    availableBadgesMap,
    allBadgesMap,
  }
}
